<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">
      Por favor, envie o arquivo geográfico a ser carregado no banco de dados
    </div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <upload-files
          :allowedFiles="allowedFiles"
          :allowedEncoding="allowedEncoding"
          :validarArquivo="validarArquivo"
          @file:uploaded="handleFileUploaded"
        />
      </v-col>
    </v-row>
    <v-row v-if="arquivosUploadados.length" class="mx-auto">
      <v-col cols="12">
        <v-row v-for="file in arquivosUploadados" :key="file.id" class="mx-auto">
          <v-col cols="11">
            <v-text-field
              :value="file.arquivo"
              :label="`Arquivo: .${file.extensao}`"
              outlined
              readonly
              prepend-inner-icon="mdi-file-outline"
            />
          </v-col>
          <v-col cols="1" class="my-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="gray"
                  min-width="0"
                  class="px-1"
                  fab
                  icon
                  x-small
                  v-bind="attrs"
                  v-on="on"
                  @click="removerArquivo(file)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Clique aqui para excluir o arquivo {{ file.arquivo }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CargasDadosGeograficosService from '@/services/CargasDadosGeograficosService';
  import UploadFiles from '@/components/general/UploadFiles/Index.vue';

  export default {
    name: 'FirstTabContent',
    components: { UploadFiles },
    data() {
      return {
        allowedFiles: [],
        allowedEncoding: ['UTF-8'],
        arquivosUploadados: []
      };
    },
    mounted() {
      this.getAllowedFiles();
    },
    methods: {
      getAllowedFiles() {
        CargasDadosGeograficosService.getAllowedFiles()
          .then((response) => (this.allowedFiles = response.data))
          .catch((error) => console.log('Error: ' + error));
      },
      handleFileUploaded(event) {
        const { files } = event;
        if (!files?.length) return;

        const extrairPrefixo = (nomeArquivo) => {
          const semExtensao = nomeArquivo.split('.')[0];
          return semExtensao.replace(/_\d+$/, '');
        };

        const prefixos = files.map((f) => extrairPrefixo(f.arquivo));
        const prefixosUnicos = [...new Set(prefixos)];

        if (prefixosUnicos.length > 1) {
          this.$toast.error('O ZIP deve conter apenas arquivos com o mesmo nome base', '', {
            position: 'topRight'
          });
          return;
        }

        this.arquivosUploadados = files;
        this.$emit('files:uploaded', files);
      },
      removerArquivo(file) {
        this.arquivosUploadados = this.arquivosUploadados.filter((f) => f.id !== file.id);
        this.$emit('files:uploaded', this.arquivosUploadados);
      },
      validarArquivo(item) {
        const extensao = item.name.split('.').pop().toLowerCase();
        if (!this.allowedFiles.includes(extensao)) {
          return 'Esse tipo de arquivo não é permitido.';
        }
        return null;
      }
    }
  };
</script>
